module.exports = new __parcel__URL__("security-preview-dark.fe257a0b.svg").toString();